// extracted by mini-css-extract-plugin
module.exports = {"btn":"styles_btn__MhmEZ","_label":"styles__label__-1htk","disable":"styles_disable__1oU73"};